import { render } from "./AccountOverrides.vue?vue&type=template&id=04b39627&scoped=true&lang=pug"
import script from "./AccountOverrides.vue?vue&type=script&lang=js"
export * from "./AccountOverrides.vue?vue&type=script&lang=js"

import "./AccountOverrides.vue?vue&type=style&index=0&id=04b39627&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b39627"]])

export default __exports__